import { apiRequest } from '../api/client';

export function acceptInvitation(token: string, password: string): Promise<void> {
  return apiRequest('/auth/invitations/accept', {
    method: 'POST',
    body: JSON.stringify({ token, password }),
  });
}
